export const ic_marker_pin_default = (index) => {
	return (
		'data:image/svg+xml;charset=UTF-8;base64,' +
		btoa(`<svg width="32" height="51" viewBox="0 0 32 51" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M30.2667 15.6333C30.2667 23.7151 17.0967 39.0467 15.6333 49.29C14.9017 39.0467 1 23.7151 1 15.6333C1 7.55157 7.55157 1 15.6333 1C23.7151 1 30.2667 7.55157 30.2667 15.6333Z" fill="#CF4727" stroke="white" stroke-width="2" stroke-linejoin="round"/>
        <text x="50%" y="40%" dominant-baseline="middle" text-anchor="middle" fill="white" font-size="15" font-family="Arial" font-weight="bold" >${index}</text>
    </svg>`)
	);
};
